import type React from 'react';
import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { capturePosthogEvent, POSTHOG_EVENTS, type TPosthogEvent } from '~/common/posthogEvents';
import { useQuery } from '~/common/routerUtils';
import store from '../store';
import ActivityFeed from './ActivityFeed';
// drawers
import Messages from './Messages';
import RequestData from './RequestData';

const eventMap: { [key: string]: TPosthogEvent } = {
  activity: POSTHOG_EVENTS.civilsearchActivityFeedViewed,
  'project-channel': POSTHOG_EVENTS.civilsearchMessagesViewed,
};

const config: { [key: string]: JSX.Element } = {
  activity: <ActivityFeed />,
  'project-channel': <Messages />,
  'request-data': <RequestData />,
};

export default function Drawers() {
  const query = useQuery();
  const { isLoading, isError, project } = useSnapshot(store) as typeof store;

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const drawer = useMemo<React.ReactNode>(() => {
    const id = query.get('drawer');
    if (id && config[id]) {
      const event = eventMap[id];

      if (event) {
        capturePosthogEvent(event, {
          ...(project && { project_id: project.id, organization_id: project.organization }),
        });
      }

      return config[id];
    }

    return null;
  }, [query]);

  if (isLoading || isError) return null;

  if (!drawer) return null;

  return (
    <div className="absolute left-0 top-0 z-40 h-full w-full bg-black/[0.439]">
      <div id={`drawer-open-${query.get('drawer')}`}>{drawer}</div>
    </div>
  );
}
